/** Display only; never replace a stored name or use this label for eligibility. */
export function accountDisplayName(name: string | null | undefined, id: number): string {
  return name == null || name.trim() === "" ? String(id) : name;
}
